import { useEffect, useState } from "react";
import { createHighlighter, type Highlighter } from "shiki/bundle/web";

const highlighterPromise = createHighlighter({
  langs: [
    "html",
    "css",
    "js",
    "graphql",
    "javascript",
    "json",
    "jsx",
    "markdown",
    "md",
    "mdx",
    "plaintext",
    "py",
    "python",
    "sh",
    "shell",
    "sql",
    "text",
    "ts",
    "tsx",
    "txt",
    "typescript",
    "zsh",
  ],
  themes: ["github-dark-default"],
});

export default function SyntaxHighlighter({
                                            code,
                                            language,
                                          }: {
  code: string;
  language: string;
}) {
  const [highlighter, setHighlighter] = useState<Highlighter | null>(null);
  const [highlightedCode, setHighlightedCode] = useState<string>("");

  useEffect(() => {
    highlighterPromise.then(setHighlighter);
  }, []);

  useEffect(() => {
    if (highlighter) {
      setHighlightedCode(
          highlighter.codeToHtml(code, {
            lang: language,
            theme: "github-dark-default",
          })
      );
    }
  }, [highlighter, code, language]);

  return (
      <div className="syntax-highlighter-wrapper text-sm overflow-x-auto max-w-full" dangerouslySetInnerHTML={{ __html: highlightedCode }} />
  );
}
